// extracted by mini-css-extract-plugin
module.exports = {"landing":"fnCzNDwv4EboaOqboL5kdg==","icon":"lbNczdj1RJlgGup9IHpnkg=="};